import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoutPageComponent } from './logout-page/logout-page.component';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
  ],
  declarations: [
    LogoutPageComponent
  ],
  exports: [
  ]
})
export class LogoutpageModule {


 }
